/**
 * 待提货 页签
 * */
import React from 'react'
import Lang from '@components/Lang/Lang'
import { Tabs, Badge, Card, Select,Input, message,Alert, Spin} from "antd";
import {isEmpty,isEmptyObject,trim,getFileSuffix,symbolMoneyUtil} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import UploadFile from '@/components/UploadFile/UploadFile'
import AuthBtn from "@components/HoverIcon/AuthBtn";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import ModalOrderDetail from "../../../components/ModalOrderDetails/ModalOrderDetail";
import ShowPickUpPoDrawer from "@components/batchPickUpPoDrawer/showPickUpPoDrawer";
import ModalShipment from "./compoents/modalShipment/index";
import ModalFeeReduction from "./compoents/modalFeeReduction/index";
import ModalAdjustOrders from "./compoents/modalAdjustOrders/index";
import Tips from "./compoents/Tips"
import TakeDeliveryAction from "./TakeDelivery.action";
import { toFixedWithCommas} from "@utils/number-util";
import dayjs from 'dayjs';
import "./index.less"
const { Option } = Select;
export default class TakeDelivery extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            waitIntoNum: "",
            tabKay: '1',//	列表页签 1:待提货 2:需送车 3:已提货
            // 搜索默认 10:客户编码 20:联系人名称 30:联系人电话
            sKeywordType: "10",
            // 上传设置
            uploadSetting : {
                name: 'fileShippingOut',
                accept:'.xlsx, .xls',
                showUploadList: false,
                // customRequest:this.handleUpload.bind(this),
                // beforeUpload:this.beforeUpload.bind(this),
                replace:true,
            },
            // 搜索 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'type',
                    type:'Enum',
                    cnTitle:'',
                    cnTitleId:'',
                    enumCanAll:true,// 配置全部选项
                    enumClass:'abd_whs_delivery_order_type',
                    enumCanAllTitle: Lang({id:"QuanBuLeiXing",default:"全部类型"}),
                    hiddenLabel: true,
                    width: 116,
                },
                {
                    name:'poCode',
                    cnTitle:'订单编号',
                    cnTitleId:'DingDanBianHao',
                    cnPlaceholder:'订单号',
                    cnPlaceholderId:'DingDanHao',
                    width:216,
                },
            ],
        }
    }
    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
        })
    }
    changeNum(waitDeliveryNum=0,hasDeliveryServiceNum=0){
        this.setState({
            waitDeliveryNum: waitDeliveryNum,
            hasDeliveryServiceNum: hasDeliveryServiceNum,
        } )
    };
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 下载文件
    getDownload(item={}){
        this.loading(true)
        TakeDeliveryAction.downloadDeliverOrder({
            deliveryOrderId:item.deliveryOrderId
        }).then(res => {
            this.loading(false)
            const data = res.data||{};
            const {success,valid,model} = data;
            if (success && valid) {
                if(model&&model.fileUrl){
                    window.open(model.fileUrl)
                }else message.info(Lang({id:"ZanWuShuJu",default:"暂无数据"}));
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    /* 停仓收费提示  -----！！！！！ dop 不显示
     * RuKuTingCangTiShi3 2023-04-20 前免费停仓，往后每延迟 1 天收费 xx 元。
     * RuKuTingCangTiShi 入库后有 {0} 天免费停仓期，延期收费 {1} 元/m³/天。
     *
     * freeEndDate  免费停仓结束日期
     * freeEndDays 剩余免费停仓天数
     * */
    // getTips(model={}){
    //     return (model.freeEndDate?<Alert type="warning" className={"ant-alert-common mt_12"}
    //                                      message={Lang({id:"RuKuTingCangTiShi3",default:"前免费停仓，往后每延迟 1 天收费 {0} 元", params:[ model.freeEndDate, symbolMoneyUtil(model.price, model.currencySymbol)]})}/>:null)
    // }
    /*  已产生 收费提示
      *  及发票列表
      *  RuKuTingCangTiShi3 2023-04-20
      *  payLogs:[{
      *      isPaid 0:未支付, 1:已支付
      *  }]
      *
      *   */
    getDownloadCost(deliveryOrderId){
        const data ={
            deliveryOrderId: deliveryOrderId
        }
        this.loading(true)
        TakeDeliveryAction.getDownloadCost(data).then((res={}) => {
            this.loading(false)
            const data = res.data||{};
            const {success,valid,model} = data;
            if(success&&valid&&model&&model.url){
                window.open(model.url);
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        }).catch(res=>{
            this.loading(false);
            message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    /* 已产生 发票列表
     * dop 不显示 收费 提示 去支付等内容
     * freeEndDate  免费停仓结束日期
     * */
    getPayMsg(payLogs=[],model={}){
        return (<div className={"invoiceListWrap black89 mt_12"}>
            {/* 减免列表 */}
            {(model.reductionList&&model.reductionList.length>0)?<>
                {model.reductionList.map((reduItem,inx)=><p className={"flex-item color-err fw_500 font_12"} key={'redu_'+inx}>
                    {reduItem.isAllReduction==1?Lang({id:"YiQuanMianFeiYong",default:"已全免费用"}):<span
                            dangerouslySetInnerHTML={{__html: Lang({id:"YiYouHuiN",
                                    params:[ `<span class="ml_8">${symbolMoneyUtil(reduItem.reductionPrice, model.currencySymbol)}</span>`] })
                            }}>
                    </span>}
                </p>)}
            </>:null}
            {/* payLogs 支付历史记录 当前产生停仓费用*/}
            {payLogs.length>0?payLogs.map((payItem,inx)=><p className={"flex-item"} key={'payLog_'+inx}>
                {/* 已支付 直接打开文件，未支付实时数据打开此接口*/}
                {payItem.isPaid==1?<a href={payItem.invoiceFileUrl} target={'_blank'} className={"black89 flex-item"}>
                    <i className="mr_2 ri-article-fill fw_700 black89 font_18"/>
                    {Lang({id:"FaPiao",default:"发票"})}
                </a>:<span onClick={()=>this.getDownloadCost(model.deliveryOrderId)} className={"cursor-p black89 flex-item"}>
                  <i className="mr_2 ri-article-fill fw_700 black89 font_18"/>
                    {Lang({id:"FaPiao",default:"发票"})}
                </span>}
                （{Lang({id:"NZhiN",default:"{0} 至 {1}",params:[payItem.startDate?dayjs(payItem.startDate).format('YYYY-MM-DD'):"-",payItem.endDate?dayjs(payItem.endDate).format('YYYY-MM-DD'):"-"]})}）
                {/* isPaid 0 未支付 1 已支付 */}
                {payItem.isPaid==1?<span className={"ml_24 fw_500 flex-item-ver-center"}>
                    <i className={"mr_4 ri-checkbox-circle-fill color-green font_16"} />
                    <span className={"mr_4"}>{payItem.createTime?dayjs(payItem.createTime).format('YYYY-MM-DD'):"-"}</span>
                    {/*已支付*/}
                    <span className={"mr_4"}>{Lang({id:"YiZhiFu",default:"已支付"})}</span>
                    {symbolMoneyUtil(payItem.payPrice, model.currencySymbol)}
                </span>:<span className={"ml_24 color-err fw_500 flex-item-ver-center"}>
                    <span className={"mr_4"}>{symbolMoneyUtil(payItem.payPrice, model.currencySymbol)}</span>
                    {Lang({id:"FeiYongWeiZhiFu",default:"费用未支付"})}
                </span>}
                </p>
            ):null}
        </div>)
    }
    /**
     * 列表
     * item 数据
     * index
     * flagAdd 是否普通出货，false 时为 显示编辑
     * flagShowAuthBtn 是否显示两个权限按钮(减免费用|调整订单)，只有在待提货 和需送车，且有权限下显示,
     * */
    renderList=(item={},index,flagAdd=true,flagShowAuthBtn=false)=>{
        return <Card className="mb_16 pickWrap black89" key={'list_'+index}>
            <div className={"flex-item-between"}>
                <div>
                    <p className="font-16">
                        <span className={"font_18 fw_700"}>{item.preDeliveryDate?dayjs(item.preDeliveryDate).format("YYYY-MM-DD"):"-"}</span>
                        <span className={"ml_12 black66"}>{item.buyerCode}</span>
                        <span className={"ml_12 black66"}>{item.buyerName}</span>
                    </p>
                    {/*  中转城市名称  预约类型名称 */}
                    <Tips item={item} />
                </div>
                <div className={"btnListWrap ml_24"}>
                    {/* 预约详情 回显 */}
                    <ShowPickUpPoDrawer poIds={item.poIds} pickupType={item.type} deliveryOrderId={item.deliveryOrderId}/>
                    <AuthBtn icon={"ri-file-excel-2-line"} className={"ml_8"} tips = {Lang({id:"TiHuoDan",default:"提货单"})}
                             onClick={()=>this.getDownload(item)} />
                    {/* 减免费用 */}
                    {flagShowAuthBtn&&<ModalFeeReduction deliveryOrderId={item.deliveryOrderId} item={item}
                                                         reductionList={item.reductionList} refreshPage={()=>this.refreshPage(this.state.currPage)} />}
                    {/* 调整订单 */}
                    {flagShowAuthBtn&&<ModalAdjustOrders deliveryOrderId={item.deliveryOrderId} refreshPage={()=>this.refreshPage(this.state.currPage)} />}
                    <ModalShipment deliveryOrderId={item.deliveryOrderId}
                                  flagAdd={flagAdd}
                                  disabled={item.canOut!=1}
                                  refreshPage={()=>this.refreshPage(this.state.currPage)}
                                  item={item} />

                </div>
            </div>
            <div className={"lineWrap"}>
                {/* :已完成提货 */}
                {/*{item.status=="20"&&<p className={"color-green font_14 fw_500"}>*/}
                    {/*{Lang({id:"YiWanChengTiHuo",default:"已完成提货"})}*/}
                    {/*<span className={"ml_2"}>{item.actDeliveryDate?moment(item.actDeliveryDate).format('YYYY-MM-DD'):"-"}</span>*/}
                {/*</p>}*/}
                {/* 已取消 */}
                {/*{item.status=="30"&&<p className={"colorGrey font_14 fw_500"}>{__getServerLanguage("YiQuXiao")}</p>}*/}
                {item.status=="10"?(<>
                    {/* 免费停仓期（2023-04-20） 剩余7天 */}
                    {item.payStatus=="10"&&item.freeEndDate&&<Alert type="warning" className={"ant-alert-common mt_8"}
                                                  message={Lang({id:"MianFeiTingCangQi",default:"免费停仓期"})
                                                  +" （"+dayjs(item.freeEndDate).format('YYYY-MM-DD')+"） "
                                                  + Lang({id:"ShengYuNTian",default:"剩余{0}天",params:[item.freeEndDays]})
                                                  }  />}
                    {/* 提货时间剩余 2 天，不提货将继续产生停仓费用 */}
                    {/*{item.payStatus=="40"&&<p className={"color-red font_14 fw_500 mt_8"}>*/}
                        {/*{Lang({id:"TiHuoShiJianShengYu",default:"提货时间剩余 {0}，不提货将继续产生停仓费用",params:[item.freeEndDays]})}*/}
                    {/*</p>}*/}
                </>):null}

                {/* 显示付款 只有 status =10 （-10:已过期作废，已无 10:已预约 20:已完成提货 30:客户取消） 订单取消后不显示 停仓收费提示*/}
                {(item.status=="10"||item.status=="20")&&<>
                    {/* payStatus
                        10:未支付过,未超过免费停仓期
                        20:未支付过,超过免费停仓期
                        30:已支付,但未提货在3天免费期内
                        40:已支付,超过3天免费停仓期
                        50:还未开始计费
                        60:未支付,但是预约提货时间超过了免费时间
                     */}
                    {(item.payStatus=="20"||item.payStatus=="30"||item.payStatus=="40"||item.payStatus=="60")?this.getPayMsg(item.payLogs,item):null}
                </>}
                {this.renderAddress(item,item.logisticsCompanyVO,index)}
                {/*  渲染 po列表 */}
                {this.renderPo(item,item.itemList,index)}
                {item.packageRemark&&<div className={"mt_12 font_12 black66"}>
                    {/* 打包要求 */}
                    <p className={"color-black fw_700"}>{__getServerLanguage("DaBaoYaoQiu")}</p>
                    <div className={"word-break-all"}>{item.packageRemark}</div>
                </div>}
            </div>
        </Card>
    }
    /*
    *  渲染 po列表
    * */
    renderPo(obj={},itemList=[],index){
        return (<div className={"poListItem"} key={'po_'+index}>
                {itemList.map((item,inx)=>(<div className={"invoice flex-item-between"} key={'po_li_'+inx}>
                    <span className={"color-blue2 cursor-p"}>
                        {/*<i className="ri-share-box-line ml_2"></i>*/}
                        <ModalOrderDetail id={item.poId}>{item.poCode} <span className={"ri-share-box-line ml_4 font_16"} /></ModalOrderDetail>
                    </span>
                    <div className={"w500 flex-item-between"}>
                        <span>{item.containerCode}</span>
                        <p className={"black66 flex-item-ver-center"}>
                            {/*箱*/}
                            <i className="ri-archive-2-line black33 mr_2"></i>
                            <span className={"font_14"}>{item.totalQuantity||'-'}{Lang({id:"Xiang",default:"箱"})}</span>
                            {/*款*/}
                            {/*<span className="tit margin-left-5">{item.totalCount||'-'}{__getServerLanguage('Kuan')}</span>，*/}
                            {/* 体积 重量*/}
                            <i className="ri-box-3-line black33 ml_20 mr_2"></i>
                            <span className={"font_14"}>{toFixedWithCommas(item.totalVolume,3)||'-'} m³</span>
                            <i className="ri-scales-2-fill black33 ml_20 mr_2"></i>
                            <span className={"font_14"}>{toFixedWithCommas(item.totalGrossWeight,3)||'-'} kg</span>
                            {/* 中转城市名称 */}
                            {/*<span className={"icon-font icon-hotel-fill black33 font_16 ml_20 mr_2"}></span>{item.transitCityName}*/}
                        </p>
                    </div>
                </div>))}
                {itemList.length>1&&<div className={"invoice text-right mt_8 fw_700 font_14"}>
                    {/*箱*/}
                    <i className="ri-archive-2-line black33 mr_2"></i>
                    <span className={"font_14"}>{obj.totalQuantity||'-'}{Lang({id:"Xiang",default:"箱"})}</span>
                    {/* 体积 重量*/}
                    <i className="ri-box-3-line black33 ml_20 mr_2"></i>
                    <span className={"font_14"}>{toFixedWithCommas(obj.poTotalVolume,3)||'-'} m³</span>
                    <i className="ri-scales-2-fill black33 ml_20 mr_2"></i>
                    <span className={"font_14"}>{toFixedWithCommas(obj.totalGrossWeight,3)||'-'} kg</span>
                </div>}
        </div>)
    }
    /**
    *  地址 和物流
    *  10:个人自提 20:第三方公司 30:配送(合作物流)
    * */
    renderAddress(item={},logisticsCompanyVO={},index){
        return (<div className={"flex-item-between mt_12"} key={"wl_"+index}>
            <div>
                {/* 详细地址 配送才会有 */}
                {/*{item.detailedAddress&&<p className={"black66"}>{item.detailedAddress}</p>}*/}
                {/* 收件人所在城市 */}
                {item.type=="30"&&<p className={"black66"}>
                    {Lang({id:"ShouJianRenSuoZaiChengShi",default:"收件人所在城市"})}
                    <span className={"ml_4"}>{item.cityName||"-"}</span>
                </p>}
                {/* 运输公司终点站 */}
                {item.type=="30"&&<p className={"black66 mb_4"}>
                    {Lang({id:"YunShuGongSiZhongDianZhan",default:"运输公司终点站"})}
                    <span className={"ml_4"}>{item.terminalName||"-"}</span>
                </p>}
                <p className={"fw_500"}>{item.contactName||"-"}</p>
                <p className={"fw_500"}>+{item.contactTelCode||"-"} {item.contactMobile||"-"}</p>
            </div>
            {/* 物流 配送才会有  */}
            {(item.type=="20"||item.type=="30")&&<>
                {item.type=="20"?<div className={"deliveryInfo"}>
                    <p className="fw_500 black89">{item.logisticsCompanyName}</p>
                    <p className="font_14 black66">
                        <span className="mr_4">
                            {Lang({id:"DanHao",default:"单号"})}
                        </span>
                        {item.logisticsNumber}
                    </p>
                </div>:(logisticsCompanyVO.logoFileUrl?<div className={"logoImg"}>
                    <img src={logisticsCompanyVO.logoFileUrl} />
                    </div>:<div className="deliveryInfo">
                    <div className={"fw_500"}>{logisticsCompanyVO.name||"-"}</div>
                    <p className={"black66"}>{logisticsCompanyVO.type==1?Lang({id:"TuiJianWuLiu",default:"推荐物流"}):Lang({id:"HeZuoWuLiu",default:"合作物流"})}</p>
                    </div>)}
            </>}
            </div>)
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    onRefAutoFetchList2 = (ref) =>  this.onRefAutoFetchListChrld2 = ref;
    onRefAutoFetchList3 = (ref) =>  this.onRefAutoFetchListChrld3 = ref;
    refreshPage(currPage=1){
        const { tabKay } = this.state;
        switch (tabKay) {
            case "1":
                this.onRefAutoFetchListChrld.handleFetch(currPage,{},true);
                return
            case "2":
                this.onRefAutoFetchListChrld2.handleFetch(currPage,{},true)
                return
            default:
                this.onRefAutoFetchListChrld3.handleFetch(currPage,{},true)
                return;
        }
    }
    // 赋值
    setInputKey(key,str){
        let curr = this.state;
        curr[key] = str;
        this.setState(curr)
    }
    // 导出
    onClickExport(){
        this.loading(true)
        TakeDeliveryAction.downloadExcel({}).then(res => {
            this.loading(false)
            const data = res.data||{};
            const {success,valid,model} = data;
            if (success && valid) {
                if(model&&model.fileUrl){
                    window.open(model.fileUrl)
                }else message.info(Lang({id:"ZanWuShuJu",default:"暂无数据"}));
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    // 上传填充
    onClickUpLoad(fileId){
        this.loading(true)
        TakeDeliveryAction.uploadExcel({
            fileId:fileId
        }).then(res => {
            this.loading(false);
            const data = res.data||{};
            const {success,valid,model={}} = data;
            if (success && valid) {
                if(model.fail||model.success){
                    message.info(Lang({id:"ChengGongGengXinNTiaoShuJuNTiaoShiBai",default:"成功更新{0}条数据，{1}条失败",params:[model.success,model.fail]}));
                }
                this.refreshPage()
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    /**
     * 上传文件后设置
     * **/
    handleUpload(file=[]){
        if(file.length>0){
            const fileId = file[0].fileId;
            this.onClickUpLoad(fileId)
        }
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    // 查询回调
    fetchCallBack(res={}){
        const { model ={}, paging={}} = res;
        this.changeNum(model.waitDeliveryNum,model.hasDeliveryServiceNum)
        this.onRefPageCommonChild.isShowTop()
        this.setState({
            currPage:paging.pageNum || 1
        })
    }
    searchReset(){
        this.setState({
            sKeyword:"",
            sKeywordType: "10",
        })
    }
    render() {
        const {loading, waitDeliveryNum,hasDeliveryServiceNum,searchFormOptions,
            tabKay,sKeywordType,sKeyword,uploadSetting,currPage } = this.state;
        return (<Spin spinning={loading}>
                    <PageCommon onRef={this.onRefPageCommon}
                            btnList={[{
                                btn: Lang({id:"DaoChu",default:"导出"}),
                                icon:"ri-download-2-line mr_4 color-blue",
                                btnClick:()=>this.onClickExport()
                                },{
                                    btn: <UploadFile {...uploadSetting}
                                                     onChange={(fileList)=>{
                                                         this.handleUpload(fileList);
                                                     }}>
                                        <i className='ri-upload-cloud-line color-yellow mr_4'></i> <span style={{color:'#fff'}}>{Lang({id:'ShangChuanTianCong',default:'上传填充'})}</span>
                                    </UploadFile>
                                }
                            ]}>
                <CommonBreadcrumb list={[
                    {name: Lang({id: 'DaiTiHuo', default: '待提货'})},
                ]}></CommonBreadcrumb>
                <div className="customer-screen">
                    <Tabs defaultActiveKey="wait" onChange={this.tabsOnChange.bind(this)}
                          items={[
                              {
                                  key: '1',
                                  label:(<div>
                                    <span className="mr_4">
                                        {Lang({id: 'DaiTiHuo', default: '待提货'})}
                                    </span>
                                      <Badge count={waitDeliveryNum}></Badge>
                                  </div>),
                                  children: <AutoFetchList onRef={this.onRefAutoFetchList}
                                                           fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                           precondition={{
                                                               listType: tabKay,// listType 必填 1:待提货 2:需送车 2:已提货
                                                               keywordType:sKeywordType,
                                                               keyword:sKeyword,
                                                               type:""
                                                           }}
                                                           searchReset={()=>this.searchReset()}
                                                           searchFormOptions={searchFormOptions}
                                                           // flagShowReset={false}
                                                           topSearchLeftCont={(<Input style={{width:"300px"}}
                                                                                      className={"mr_12"}
                                                                                      value={sKeyword}
                                                                                      addonBefore={<Select value={sKeywordType} onSelect={(value)=>this.setInputKey("sKeywordType", value)}>
                                                                                          <Option value={"10"}>{Lang({id:"KeHuBianHao",default:"客户编号"})}</Option>
                                                                                          <Option value={"20"}>{Lang({id:"LianXiRenMinCheng",default:"联系人名称"})}</Option>
                                                                                          <Option value={"30"}>{Lang({id:"LianXiRenDianHua",default:"联系人电话"})}</Option>
                                                                                      </Select>}
                                                                                      placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                                                                      onChange={(e)=>this.setInputKey("sKeyword",e.target.value,)}
                                                           />)}
                                                           fetchApi={'/service/mg/whs/delivery/list'}
                                                           renderList={(item,inx)=>this.renderList(item,inx,true,true)}  />
                              },
                              {
                                  key: '2',
                                  label:(<div>
                                    <span className="mr_4">
                                        {Lang({id: 'XuSongChe', default: '需送车'})}
                                    </span>
                                      <Badge count={hasDeliveryServiceNum}></Badge>
                                  </div>),
                                  children: <AutoFetchList onRef={this.onRefAutoFetchList2}
                                                           fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                           precondition={{
                                                               listType: tabKay,// listType 必填 1:待提货 2:需送车 2:已提货
                                                               keywordType:sKeywordType,
                                                               keyword:sKeyword,
                                                               type:""
                                                           }}
                                                           searchReset={()=>this.searchReset()}
                                                           searchFormOptions={searchFormOptions}
                                                           // flagShowReset={false}
                                                           topSearchLeftCont={(<Input style={{width:"300px"}}
                                                                                      className={"mr_12"}
                                                                                      value={sKeyword}
                                                                                      addonBefore={<Select value={sKeywordType} onSelect={(value)=>this.setInputKey("sKeywordType", value)}>
                                                                                          <Option value={"10"}>{Lang({id:"KeHuBianHao",default:"客户编号"})}</Option>
                                                                                          <Option value={"20"}>{Lang({id:"LianXiRenMinCheng",default:"联系人名称"})}</Option>
                                                                                          <Option value={"30"}>{Lang({id:"LianXiRenDianHua",default:"联系人电话"})}</Option>
                                                                                      </Select>}
                                                                                      placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                                                                      onChange={(e)=>this.setInputKey("sKeyword",e.target.value,)}
                                                           />)}
                                                           fetchApi={'/service/mg/whs/delivery/list'}
                                                           renderList={(item,inx)=>this.renderList(item,inx,true,true)}  />
                              },
                              {
                                  key: '3',
                                  label:(<div>
                                    <span className="mr_4">
                                        {Lang({id: 'YiTiHuo', default: '已提货'})}
                                    </span>
                                  </div>),
                                  children: <AutoFetchList onRef={this.onRefAutoFetchList3}
                                                           fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                           precondition={{
                                                               listType: tabKay,// listType 必填 1:待提货 2:需送车 2:已提货
                                                               keywordType:sKeywordType,
                                                               keyword:sKeyword,
                                                               type:""
                                                           }}
                                                           searchReset={()=>this.searchReset()}
                                                           searchFormOptions={searchFormOptions}
                                                           // flagShowReset={false}
                                                           topSearchLeftCont={(<Input style={{width:"300px"}}
                                                                                      className={"mr_12"}
                                                                                      value={sKeyword}
                                                                                      addonBefore={<Select value={sKeywordType} onSelect={(value)=>this.setInputKey("sKeywordType", value)}>
                                                                                          <Option value={"10"}>{Lang({id:"KeHuBianHao",default:"客户编号"})}</Option>
                                                                                          <Option value={"20"}>{Lang({id:"LianXiRenMinCheng",default:"联系人名称"})}</Option>
                                                                                          <Option value={"30"}>{Lang({id:"LianXiRenDianHua",default:"联系人电话"})}</Option>
                                                                                      </Select>}
                                                                                      placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                                                                      onChange={(e)=>this.setInputKey("sKeyword",e.target.value,)}
                                                           />)}
                                                           fetchApi={'/service/mg/whs/delivery/list'}
                                                           renderList={(item,inx)=>this.renderList(item,inx,false)} />
                              }
                          ]}
                    />

                </div>
            </PageCommon>
      </Spin>)
    }
}

